import { render, staticRenderFns } from "./PlayerText.vue?vue&type=template&id=9a5bdcee&scoped=true"
import script from "./PlayerText.vue?vue&type=script&lang=js"
export * from "./PlayerText.vue?vue&type=script&lang=js"
import style0 from "./PlayerText.vue?vue&type=style&index=0&id=9a5bdcee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5bdcee",
  null
  
)

export default component.exports